import React from 'react'
import classNames from 'classnames/bind'
import { useRouter } from 'next/router'

// Libs
import handleRoutePushWithQuery from '@/methods/url/handleRoutePushWithQuery'

// Components
import Option from '../Option'

// Constants
import { ROUTE_PATH } from '@/constants/routePath'
import { SEARCH_TYPE } from '@/constants/search'

// Styles
import styles from './style.module.scss'

const cx = classNames.bind(styles)

interface Props {
  className?: string
  isOpen: boolean
  filterKeyWord: {
    keyword: string
  }[]
  handleClick: (keyword: string) => void
  activeIndex: number | null
}

const AutoComplete = ({ className, filterKeyWord, isOpen, handleClick, activeIndex }: Props) => {
  const router = useRouter()
  return (
    <>
      {isOpen && (
        <div className={cx('search-input__auto-complete', className)}>
          {filterKeyWord.map((item: any, index: number) => (
            <Option
              keyword={item.keyword}
              key={index}
              handleClick={() => {
                handleRoutePushWithQuery({
                  router,
                  pathname: ROUTE_PATH.SEARCH,
                  query: { keyword: item.keyword, type: SEARCH_TYPE.ALL },
                })
                handleClick(item.keyword)
              }}
              active={index === activeIndex}
            />
          ))}
        </div>
      )}
    </>
  )
}
export default AutoComplete
